<template>
	<div style="background-color: #fff;padding: 20px;" class="container-top">
		<!-- 右上角 返回按钮 -->
		<div class="header">
			<a-button @click="goBack" class="back-btn">
				<a-icon type="left" /> 返回
			</a-button>
		</div>
		<div class="titleCz">意见反馈信息</div>
		<a-descriptions :column="1" bordered style="flex: 1;">
			<a-descriptions-item label="反馈单号">
				{{detailModel.feedbackNo}}
			</a-descriptions-item>
			<a-descriptions-item label="用户名称">
				{{detailModel.nickname }}
			</a-descriptions-item>

			<a-descriptions-item label="反馈时间">
				{{detailModel.createTime}}
			</a-descriptions-item>
			<a-descriptions-item label="手机号码">
				{{detailModel.userPhone}}
			</a-descriptions-item>


			<a-descriptions-item label="微信号码">
				{{detailModel.userWechat}}
			</a-descriptions-item>
			<a-descriptions-item label="反馈内容">
				<div>{{ detailModel.feedbackContent }}</div>
				<div v-if="detailModel.feedbackImages" v-viewer style="display:flex;gap:8px;flex-wrap:wrap;margin-top:8px;">
					<img v-for="(img,i) in detailModel.feedbackImages.split(';').filter(u=>u)" :key="i" :src="img"
						style="width:80px;height:80px;object-fit:cover;border:1px solid #eee;cursor:pointer;border-radius:4px;" />
				</div>
			</a-descriptions-item>
			<!-- show-search option-filter-prop="name" -->
			<a-descriptions-item :label="`回复反馈（${ detailModel.replyStatus == 'SENT' ? '已发送' : '未发送'}）`">
				<a-select @change="hhChange" style="width: 200px"  class="mr12" placeholder="选择话术"  show-search option-filter-prop="name" :filter-option="filterOption" :disabled="detailModel.replyStatus == 'SENT'">
					<a-select-option v-for="(item, index) of hhData" :key="index" :value="item.templateId">
						{{ item.templateContent }}
					</a-select-option>
				</a-select>
				<a-textarea style="margin-top:10px" placeholder="输入回复内容" v-model="detailModel.replyContent" :disabled="detailModel.replyStatus == 'SENT'" />

				<!-- 发送按钮是否置灰，"detailModel.replyStatus": null, //发送状态：SENT-已发送 FAILED-发送失败 PENDING-待发送 -->
				 <!-- 已发送的时候，置灰 -->
				<a-button style="margin-top:10px" @click="send"  :disabled="detailModel.replyStatus == 'SENT'"  :loading="sendLoading" type="primary">发送</a-button>
			</a-descriptions-item>
			<a-descriptions-item label="反馈状态">
				<a-select style="width: 200px" v-model="detailModel.status" class="mr12" placeholder="请选择处理状态"
					show-search option-filter-prop="name" :filter-option="filterOption">
					<a-select-option v-for="(item, index) of tags" :key="index" :value="item.tagId">
						{{ item.tagName }}
					</a-select-option>
				</a-select>
			</a-descriptions-item>
			<a-descriptions-item label="备注">
				<a-textarea placeholder="输入备注内容（后台查看不同步前端）" v-model="detailModel.remark" />
			</a-descriptions-item>
		</a-descriptions>
		<div style="height: 40px;"></div>
		<a-button @click="sureEdit" type="primary">保存</a-button>
		<div style="height: 40px;"></div>
		<div class="titleCz">操作日志</div>
		<a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
			:loading="loading">
		</a-table>

		<a-modal title="留言及回复" :visible="replyModal" width="1000px" :footer="null" @cancel="replyModal = false">
			<div v-if="currentComment">
				<!-- 原评价 -->
				<div style="padding:12px;background:#f5f5f5;border-radius:6px;margin-bottom:16px;">
					<div style="display:flex;align-items:center;margin-bottom:8px;">
						<div v-viewer style="display:inline-block;cursor:pointer;flex-shrink:0;margin-right:8px;">
							<img v-if="currentComment.avatar" :src="currentComment.avatar"
								 style="width:36px;height:36px;border-radius:50%;object-fit:cover;"/>
						</div>
						<span style="font-weight:500;">{{currentComment.nickname}}</span>
						<a-tag v-if="currentComment.tagName" color="#2CBD9C" style="margin-left: 6px;">
							{{currentComment.tagName}}
						</a-tag>
						<a-tag v-if="currentComment.pinStatus" color="#1890ff" style="margin-left:6px;">置顶</a-tag>
						<a-tag v-if="currentComment.blackStatus" color="black" style="margin-left:6px;">黑名单</a-tag>
						<a-tag v-if="currentComment.hiddenStatus" color="#faad14" style="margin-left:6px;">屏蔽</a-tag>
						<span v-if="currentComment.score" style="display:inline-flex;align-items:center;margin-left:6px;vertical-align:middle;">
                                <a-rate :value="currentComment.score" disabled allow-half style="font-size:14px;"/>
                                <span style="margin-left:4px;font-size:13px;color:#666;">{{ currentComment.score }}</span>
                                <a-button type="link" size="small" @click="showScoreDetail(currentComment)" style="font-size:18px;line-height:1;padding:0 4px;min-width:auto;">⋮</a-button>
                            </span>
					</div>
					<div style="padding-left:44px;font-size:14px;color:#333;margin-bottom:6px;">{{currentComment.comment}}</div>
					<div v-viewer style="padding-left:44px;margin-bottom:6px;">
						<img v-for="(img,i) in (currentComment.commentImages||'').split(/[,;]/).filter(u=>u)" :key="i" :src="img" style="width:80px;height:80px;object-fit:cover;border:1px solid #eee;cursor:pointer;margin-right:6px;" />
					</div>
					<div style="padding-left:44px;font-size:12px;color:#999;">{{currentComment.publicTime}}</div>
					<!-- 统计操作栏 -->
					<div style="display:flex;align-items:center;justify-content:space-between;padding-left:44px;margin-top:6px;">
						<div></div>
						<div style="display:flex;align-items:center;gap:12px;">
							<span style="color:#999;"><a-icon type="eye"/> {{currentComment.viewNum || 0}}</span>
							<span style="cursor:pointer;color:#999;" @click="handleLike(currentComment)"><a-icon type="like"/> {{(currentComment.likeNum || 0) + (currentComment.virtualLikeNum || 0)}}</span>
							<span style="cursor:pointer;color:#999;" @click="openReplyWrite(currentComment, null)"><a-icon type="message"/> {{currentComment.commentNum || 0}}</span>
							<a-dropdown>
								<a-icon type="ellipsis" style="cursor:pointer;color:#999;font-size:16px;"/>
								<a-menu slot="overlay">
									<a-menu-item v-if="!currentComment.hiddenStatus" @click="handleHide(currentComment)">隐藏</a-menu-item>
									<a-menu-item v-if="currentComment.hiddenStatus" @click="handleUnhide(currentComment)">恢复显示</a-menu-item>
									<a-menu-item v-if="!currentComment.blackStatus && currentComment.userId" @click="handleBlack(currentComment)">拉黑用户</a-menu-item>
									<a-menu-item v-if="currentComment.blackStatus && currentComment.userId" @click="handleUnblack(currentComment)">取消拉黑</a-menu-item>
									<a-menu-item v-if="!currentComment.pinStatus" @click="handlePin(currentComment)">置顶</a-menu-item>
									<a-menu-item v-if="currentComment.pinStatus" @click="handleUnpin(currentComment)">取消置顶</a-menu-item>
									<a-menu-item @click="handleDelete(currentComment)">删除</a-menu-item>
								</a-menu>
							</a-dropdown>
						</div>
					</div>
				</div>
				<div v-if="replyDetailList && replyDetailList.length" style="padding-left:44px;">
					<div v-for="(item, idx) in replyDetailList" :key="item.replyId || idx"
						 style="margin-top:10px;border-bottom:1px solid #f7f7f7;padding-bottom:8px;">
						<!-- 头像、昵称、标签 -->
						<div style="display:flex;align-items:center;">
							<div v-viewer style="width:36px;height:36px;border-radius:18px;border:2px solid #f7f7f7;overflow:hidden;flex-shrink:0;cursor:pointer;">
								<img style="width:36px;height:36px;border-radius:18px;object-fit:cover;"
									 v-if="item.replyAvatar" :src="item.replyAvatar" alt=""/>
							</div>
							<div style="margin-left:8px;">
								{{item.replyName || '匿名'}}
								<a-tag v-if="item.pinStatus" color="#1890ff" style="margin-left:6px;">置顶</a-tag>
								<a-tag v-if="item.blackStatus" color="black" style="margin-left:6px;">黑名单</a-tag>
								<a-tag v-if="item.hiddenStatus" color="#faad14" style="margin-left:6px;">屏蔽</a-tag>
							</div>
						</div>
						<!-- 回复内容 -->
						<div style="padding-left:44px;"><span v-if="item.targetName" >@{{item.targetName}}：</span>{{item.replyContent}}</div>
						<!-- 回复图片 -->
						<div v-if="item.replyImgArr && item.replyImgArr.length" v-viewer
							 style="display:flex;gap:8px;margin-top:8px;flex-wrap:wrap;padding-left:44px;">
							<img v-for="(imgUrl, i) in item.replyImgArr" :key="i" :src="imgUrl"
								 style="width:80px;height:80px;object-fit:cover;border:1px solid #eee;cursor:pointer;"
								 alt=""/>
						</div>
						<!-- 底部栏：时间、统计、操作 -->
						<div style="display:flex;align-items:center;justify-content:space-between;padding-left:44px;">
							<div style="font-size:12px;color:#999;">{{item.replyTime || ''}}</div>
							<div style="display:flex;align-items:center;gap:12px;">
								<span style="color:#999;"><a-icon type="eye"/> {{item.viewNum || 0}}</span>
								<span style="cursor:pointer;color:#999;" @click="handleLike(item)"><a-icon type="like"/> {{(item.likeNum || 0) + (item.virtualLikeNum || 0)}}</span>
								<span style="cursor:pointer;color:#999;" @click="openReplyWrite(currentComment, item)"><a-icon type="message"/> {{item.commentNum || 0}}</span>
								<a-dropdown>
									<a-icon type="ellipsis" style="cursor:pointer;color:#999;font-size:16px;"/>
									<a-menu slot="overlay">
										<a-menu-item v-if="!item.hiddenStatus" @click="handleHideReply(currentComment, item)">屏蔽此留言</a-menu-item>
										<a-menu-item v-if="item.hiddenStatus" @click="handleUnhideReply(currentComment, item)">恢复此留言</a-menu-item>
										<a-menu-item v-if="!item.blackStatus && item.replyUserId" @click="handleBlack(item)">加入黑名单</a-menu-item>
										<a-menu-item v-if="item.blackStatus && item.replyUserId" @click="handleUnblack(item)">取消黑名单</a-menu-item>
										<a-menu-item v-if="!item.pinStatus" @click="handlePinReply(currentComment, item)">置顶</a-menu-item>
										<a-menu-item v-if="item.pinStatus" @click="handleUnpinReply(currentComment, item)">取消置顶</a-menu-item>
										<a-menu-item @click="handleDeleteReplyInModal(item)">删除</a-menu-item>
									</a-menu>
								</a-dropdown>
							</div>
						</div>
						<!-- 嵌套回复 (replay) -->
						<div v-if="item.replay && item.replay.length" style="padding-left:44px;margin-top:6px;">
							<div v-for="(rp, ri) in item.replay" :key="ri" v-if="rp"
								 style="background:#f7f7f7;padding:4px 8px;border-radius:4px;margin-bottom:6px;">
								<div style="display:flex;align-items:center;">
									<div v-viewer style="display:inline-block;cursor:pointer;flex-shrink:0;">
										<img v-if="rp.replyAvatar" :src="rp.replyAvatar"
											 style="width:24px;height:24px;border-radius:12px;object-fit:cover;" alt=""/>
									</div>
									<span style="margin-left:6px;font-weight:500;font-size:13px;">{{rp.replyName || '匿名'}}</span>
									<a-tag v-if="rp.pinStatus" color="#1890ff" style="margin-left:6px;font-size:11px;">置顶</a-tag>
									<a-tag v-if="rp.blackStatus" color="black" style="margin-left:6px;font-size:11px;">黑名单</a-tag>
									<a-tag v-if="rp.hiddenStatus" color="#faad14" style="margin-left:6px;font-size:11px;">屏蔽</a-tag>
								</div>
								<div style="font-size:13px;color:#333;margin-top:4px;padding-left:30px;"><span v-if="rp.targetName" >@{{rp.targetName}}：</span>{{rp.replyContent}}</div>
								<div v-if="rp.replyImgArr && rp.replyImgArr.length" v-viewer
									 style="display:flex;gap:6px;margin-top:4px;flex-wrap:wrap;padding-left:30px;">
									<img v-for="(rimg, rii) in rp.replyImgArr" :key="rii" :src="rimg"
										 style="width:60px;height:60px;object-fit:cover;border:1px solid #eee;cursor:pointer;" alt=""/>
								</div>
								<div style="display:flex;align-items:center;justify-content:space-between;margin-top:2px;padding-left:30px;">
									<div style="font-size:12px;color:#999;">{{rp.replyTime}}</div>
									<div style="display:flex;align-items:center;gap:8px;">
										<span style="cursor:pointer;color:#999;" @click="handleLikeReply(currentComment, rp)"><a-icon type="like"/>{{(rp.likeNum || 0) + (rp.virtualLikeNum || 0)}}</span>
										<span style="cursor:pointer;color:#999;" @click="openReplyWrite(currentComment, rp)"><a-icon type="message"/> {{rp.commentNum || 0}}</span>
										<a-dropdown>
											<a-icon type="ellipsis" style="cursor:pointer;color:#999;font-size:16px;"/>
											<a-menu slot="overlay">
												<a-menu-item v-if="!rp.hiddenStatus" @click="handleHideReply(currentComment, rp)">屏蔽此留言</a-menu-item>
												<a-menu-item v-if="rp.hiddenStatus" @click="handleUnhideReply(currentComment, rp)">恢复此留言</a-menu-item>
												<a-menu-item v-if="!rp.blackStatus && rp.replyUserId" @click="handleBlack(rp)">加入黑名单</a-menu-item>
												<a-menu-item v-if="rp.blackStatus && rp.replyUserId" @click="handleUnblack(rp)">取消黑名单</a-menu-item>
												<a-menu-item v-if="!rp.pinStatus" @click="handlePinReply(currentComment, rp)">置顶</a-menu-item>
												<a-menu-item v-if="rp.pinStatus" @click="handleUnpinReply(currentComment, rp)">取消置顶</a-menu-item>
												<a-menu-item @click="handleDeleteReply(currentComment, rp)">删除</a-menu-item>
											</a-menu>
										</a-dropdown>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else style="text-align:center;padding:30px 0;color:#999;">暂无回复</div>
				<!-- 分页器 -->
				<a-pagination size="small"
							  :current="replyDetailPageInfo.current"
							  :total="replyDetailPageInfo.total"
							  :pageSize="replyDetailPageInfo.pageSize"
							  v-if="replyDetailPageInfo.total > 0"
							  @change="handleReplyDetailPageChange"
							  style="text-align:center;margin-top:12px;"/>
			</div>
		</a-modal>


	</div>
</template>

<script>
	import moment from 'moment'
	import {
		ossUpload
	} from "../../utils/oss";
	import {
		getFeedbackDetailApi,
		operationLogApi,
		editFeedbackApi,
		getReplyTemplateListApi,
		sendFeedbackMessageApi
	} from "../../api/index";

	export default {
		name: "ADDETAIL",
		data() {
			return {
				hhText:"",
				sendLoading: false,
				"factoryThumbnail": "/uploads/thumbnail/factory1.jpg",
				bannerUrl: "",
				form: this.$form.createForm(this),
				detailModel: {

				},
				tags: [{
						tagId: 'PENDING',
						tagName: "待处理",
					},
					{
						tagId: 'PROCESSING',
						tagName: "处理中",
					},
					{
						tagId: 'RESOLVED',
						tagName: "已处理",
					}
				],
				commodityStatusList: [{
						label: "开启",
						value: true,
					},
					{
						label: "关闭",
						value: false,
					},
				],
				columns: [{
						title: "操作员",
						dataIndex: "operator",
						key: "operator",
					},
					{
						title: "操作",
						dataIndex: "operation",
						key: "operation",
					},
					{
						title: "时间",
						dataIndex: "operationTime",
						key: "operationTime",
					}
				],
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				feedbackId: null,
				hhData:[],
				innerType: undefined,
				radioStyle: {
					display: 'block',
					height: '30px',
					lineHeight: '30px',
				},

			};
		},
		methods: {
			hhChange(e){
				const res=this.hhData.filter(v=>v.templateId==e)[0].templateContent
				this.detailModel.replyContent=res
			},
			onChange(e) {
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			goBack() {this.$router.back();},
			innerTypechangeTabTop(e) {

			},
			send(){
				this.sendLoading = true
				let params = {
					"feedbackId": this.feedbackId,
					"replyContent":this.detailModel.replyContent
				}
				sendFeedbackMessageApi(params)
					.then((res) => {
						this.sendLoading = false
						if (res.resultStatus) {
							this.getDetails();
							this.$message.success(
								'消息发送成功'
								// this.editModel.feedbackId ? "编辑成功" : "新增成功"
							);
							this.getData(1)
						} else {
						}
					})
					.catch((error) => {
						this.sendLoading = false
					})
					.finally(() => {})

			},
			sureEdit() {
				let params = {
					"feedbackId": this.feedbackId,
					"status": this.detailModel.status,
					"remark": this.detailModel.remark,
					"replyContent":this.detailModel.replyContent
				}
				editFeedbackApi(params)
					.then((res) => {
						if (res.resultStatus) {
							this.getDetails();
							this.$message.success(
								'保存成功'
								// this.editModel.feedbackId ? "编辑成功" : "新增成功"
							);
							this.getData(1)
						} else {
						}
					})
					.catch((error) => {
						this.sendLoading = false
					})
					.finally(() => {})
			},
			disabledDate(current) {
				return current && current < moment().subtract(1, 'days').endOf('day')
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},

			handleUpdataFile(e) {
				if (e.target.files.length) {
					if (e.target.files.length) {
						const file = e.target.files[0];
						if (file) {
							ossUpload(file, '', 'image/').then((res) => {

								this.form.setFieldsValue({
									bannerUrl: res.url
								});
								this.detailModel.bannerUrl = res.url;
							}).catch(err => {
								this.$message.error('图片上传失败')
							});
						}
					}
				}
			},
			changePage(page) {
				this.pageInfo.current = page.current;
				this.getDetails();
			},

			getData(page = 1) {
				this.pageInfo.current = page;
				if (this.loading) {
					return;
				}
				this.loading = true;
				operationLogApi({
						pageNo: this.pageInfo.current,
						pageSize: this.pageInfo.pageSize,
						userId: this.feedbackId,
						targetType: 'FEEDBACK',
					})
					.then((res) => {
						if (res.resultStatus) {
							this.tableData = res.resultData.dataList || [];

							this.pageInfo.total = res.resultData.totalNum || 0;
							this.orderStaticsVO = res.resultData.userStatics
						} else {
							this.tableData = [];
							this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			// here123
			getDetails() {
				this.$nextTick(() => {
					getFeedbackDetailApi({
						feedbackId: this.feedbackId,
					}).then((res) => {
						if (res.resultStatus) {
							const result = res.resultData;
							this.detailModel = {
								"feedbackId": result.feedbackId,
								"feedbackNo": result.feedbackNo, //反馈单号
								"nickname": result.nickname, //用户名称
								"userPhone": result.userPhone, //手机号码
								"userWechat": result.userWechat, //微信号码
								"feedbackContent":result.feedbackContent, //反馈内容
								"feedbackImages": result.feedbackImages, //反馈图片（多个用;隔开）
								"createTime": result.createTime, //时间
								"status": result.status, //处理状态：PENDING-待处理 PROCESSING-处理中 RESOLVED-已解决 CLOSED-已关闭
								"replyStatus": result.replyStatus, //发送状态：SENT-已发送 FAILED-发送失败 PENDING-待发送
								"replyContent":result.replyContent, //回复反馈
								"remark": result.remark //备注
							};
						} else {
							this.$message.warn(res.errorMessage);
							this.detailModel = {

							};
						}
					});

				})


			},
			getHh(val) {
				getReplyTemplateListApi({
						pageNo: 1,
						pageSize:1000,
						templateType: val,
						keywords: '',
						lang:'CH',
					})
					.then((res) => {
						if (res.resultStatus) {
							this.hhData = res.resultData.records || [];
						} else {
							this.hhData = [];
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
		},
		mounted() {
			const feedbackId = this.$route.params.id;
			this.feedbackId = feedbackId
			this.getHh('TO_FEEDBACK')
			if (this.feedbackId) {
				this.getDetails(this.feedbackId)
			} else {
				this.form.setFieldsValue({
					bannerImageType: 'IMAGE'
				})
			}
			this.getData(1)

		},
		activated() {},
	};
</script>

<style lang="less" scoped>
	.titleCz {
		font-size: 18px;
		font-size: 18px;
		color: #333333;
		line-height: 18px;
		margin-bottom: 30px;
	}

	.container-top {
		padding: 20px;
		background-color: #fff;
		width: 800px;
		margin-left: 80px;

		/* 右上角按钮 */
		.header {
			text-align: right;
			margin-bottom: 16px;
		}

		.title {
			font-size: 18px;
			color: #333333;
			line-height: 18px;
			// margin-bottom: 30px;
		}

		.titleCz {
			font-size: 18px;
			font-size: 18px;
			color: #333333;
			line-height: 18px;
			margin-bottom: 30px;
		}

		.ant-form-item {
			// margin-bottom: 0px !important;
		}
	}
</style>
